export default __webpack_public_path__ + "static/impersonator-scam-alert-1-6253c839b8e0a308122bdc2777870488.webp";